import { render, staticRenderFns } from "./CustomerMenuSection.vue?vue&type=template&id=452c04f4&scoped=true&"
import script from "./CustomerMenuSection.vue?vue&type=script&lang=js&"
export * from "./CustomerMenuSection.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMenuSection.vue?vue&type=style&index=0&id=452c04f4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c04f4",
  null
  
)

export default component.exports